class TextScramble {
    constructor(element) {
        this.element = element
        this.input = null
        this.prefix = ''
        this.suffix = ''
        this.isScrambling = false
        this.intervalId = null
        this.charset = `!"#$%&0123456789`
        this.charsetLength = this.charset.length
        this.scrambleIteration = this.scrambleIteration.bind(this)
        this.init()
    }

    handleActiveelement = (element) => {
        if (this.activeelement) {
            this.activeelement.removeAttribute('aria-current')
        }
        this.activeelement = element
        this.activeelement.setAttribute('aria-current', 'page')
    }

    startScramble = (element) => {
        if (this.isScrambling) {
            this.stopScramble(this.activeelement)
        }
        this.isScrambling = true
        this.input = element.textContent
        this.prefix = ''
        this.suffix = this.randomChars(this.input.length)
        this.intervalId = setInterval(() => this.scrambleIteration(element), 100)
    }

    scrambleIteration = (element) => {
        let nextChar = this.input.charAt(this.prefix.length)
        if (nextChar === '') {
            this.stopScramble(element)
        } else {
            this.prefix += nextChar
            this.suffix = this.randomChars(this.input.length - this.prefix.length)
            element.textContent = this.prefix + this.suffix
        }
    }

    stopScramble = (element) => {
        element.textContent = this.input
        element.setAttribute('data-scramble-suffix', '')
        this.isScrambling = false
        clearInterval(this.intervalId)
    }

    randomChars = (length) => {
        let result = ''
        for (let i = 0; i < length; i++) {
            const randomIndex = Math.floor(Math.random() * this.charsetLength)
            result += `${this.charset[randomIndex]}`
        }
        return result
    }

    init = () => {
        this.startScramble(this.element)
    }
}

const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const scrambleTexts = entry.target.querySelectorAll("[data-text-scramble]");
          scrambleTexts.forEach((text) => {
            const scrambleTexts = text.querySelectorAll('span');
            scrambleTexts.forEach((text) => new TextScramble(text))
          });
          console.log(entry.target, scrambleTexts)
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.4 }
  );

// const scrambleElements = document.querySelectorAll('[data-text-scramble]')
// scrambleElements.forEach((element) => {
//     const scrambleTexts = element.querySelectorAll('span')
//     scrambleTexts.forEach((text) => new TextScramble(text))
// })

const aboutDesigner = document.querySelector(".about-designer");
if (aboutDesigner) {
  observer.observe(aboutDesigner);
}